const getVisibilityState = (rootState) => rootState.ui.editor.isShown;

export default getVisibilityState;
